import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { ApiService } from '../shared/services/api.service';
import { ToastService } from '../shared/services/toast.service';

@Component({
  selector: "app-credit-application",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./credit-application.component.html",
  styleUrl: "./credit-application.component.css",
})
export class CreditApplicationComponent {
  constructor(
    private router: Router,
    private apiService: ApiService,
    private toastService: ToastService
  ) {}

  steps: string[] = [
    "Datos personales",
    "Datos laborales y financieros",
    "Verificación de identidad",
    "Documentacion",
    "Historial crediticio",
  ];

  showHeaders(): void {
    console.log('Consultando show-headers...');
    
    this.apiService.showHeaders().subscribe({
      next: (response) => {
        console.log('Headers response:', response);
        this.toastService.showSuccess('Headers obtenidos exitosamente');
      },
      error: (error) => {
        console.error('Error al obtener headers:', error);
        this.toastService.showError('Error al consultar headers');
      }
    });
  } 

  onRegister(): void {
    this.router.navigate(['/registration']);
  }
}
